// src/components/Header.js
import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// --- 아이콘 컴포넌트 정의 ---
const MenuIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" /></svg>);
const CloseIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>);
// --- 여기까지 아이콘 정의 ---

// Accept modal control functions as props
function Header({ openReviewsModal, openPortfolioModal }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // Removed isReviewsModalOpen state
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  // Effect for scroll detection
  useEffect(() => {
    const handleScroll = () => { setIsScrolled(window.scrollY > 10); };
    window.addEventListener('scroll', handleScroll);
    return () => { window.removeEventListener('scroll', handleScroll); };
  }, []);

  // Effect for handling clicks outside the menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen &&
        menuRef.current && !menuRef.current.contains(event.target) &&
        buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };
    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  // Handle scroll to section if navigated with state
  useEffect(() => {
    if (location.pathname === '/' && location.state && location.state.scrollTo) {
      const sectionId = location.state.scrollTo;
      const element = document.getElementById(sectionId);
      if (element) {
        // Add a small delay to ensure page render
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
          // Clear state to prevent scrolling on subsequent renders
          window.history.replaceState({}, document.title);
        }, 100);
      }
    }
  }, [location]);

  // Function to toggle mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Function to close menu when a link is clicked
  const closeMenu = () => {
    setIsMenuOpen(false);
  }

  // Function to scroll to top when logo is clicked
  const scrollToTop = () => {
    if (location.pathname !== '/') {
      navigate('/');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    closeMenu();
  };

  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    closeMenu();

    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/', { state: { scrollTo: sectionId } });
    }
  };

  // --- Functions to open modals (using props) ---
  const handleOpenReviewsModal = (event) => {
    event.preventDefault(); // Prevent default link behavior if it's a link/button
    openReviewsModal(); // Call function passed from App.js
    closeMenu(); // Close mobile menu if open
  };

  const handleOpenPortfolioModal = (event) => {
    event.preventDefault();
    openPortfolioModal(); // Call function passed from App.js
    closeMenu();
  }
  // --- End functions to open modals ---


  return (
    // Removed Fragment wrapper, modal is rendered in App.js
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        {/* Logo */}
        <div className="logo" onClick={scrollToTop} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
          {/* Use relative path from 'public' folder */}
          <img src="/img/logo.png" alt="맑은뷰연구소 로고" style={{ height: '30px', marginRight: '10px' }} />
          <img src="/img/맑은뷰연구소.Outline.svg" alt="맑은뷰연구소" style={{ height: '40px', marginRight: '10px' }} />
        </div>

        {/* Desktop Navigation */}
        <nav className="nav-links">
          <a href="#about" onClick={(e) => handleNavClick(e, 'about')}>맑은뷰연구소</a>
          <a href="#services" onClick={(e) => handleNavClick(e, 'services')}>서비스</a>
          {/* Added "시공 사례" button */}
          <button onClick={handleOpenPortfolioModal}>시공 사례</button>
          {/* Modified "고객 후기" to be a button */}
          <button onClick={handleOpenReviewsModal}>고객 후기</button>
          <a href="#contact" onClick={(e) => handleNavClick(e, 'contact')}>문의하기</a>
        </nav>

        {/* Mobile Menu Button */}
        <button ref={buttonRef} className="mobile-menu-button" onClick={toggleMenu} aria-label="메뉴 토글">
          {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
        </button>

        {/* Mobile Navigation Menu */}
        <nav ref={menuRef} className={`mobile-nav-links ${isMenuOpen ? 'open' : ''}`}>
          <a href="#about" onClick={(e) => handleNavClick(e, 'about')}>맑은뷰연구소</a>
          <a href="#services" onClick={(e) => handleNavClick(e, 'services')}>서비스</a>
          {/* Added "시공 사례" button */}
          <button onClick={handleOpenPortfolioModal}>시공 사례</button>
          {/* Modified "고객 후기" to be a button */}
          <button onClick={handleOpenReviewsModal}>고객 후기</button>
          <a href="#contact" onClick={(e) => handleNavClick(e, 'contact')}>문의하기</a>
        </nav>
      </div>
    </header>
    // Removed Modal rendering from here
  );
}

export default Header;